import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { PageHero } from "@/components/PageHero";
import { Classes } from "@/components/Classes";
import { RelatedLinks } from "@/components/RelatedLinks";
import { usePageMeta } from "@/hooks/usePageMeta";
import { SITE } from "@/data/site";

export default function TrainingPage() {
  usePageMeta(
    "Weekly Training",
    "Weekly street dance training across London & Kent — Hip-Hop, Afro, Dancehall, Krump, Amapiano, Freestyle & Battle Training, and Performance Development."
  );
  return (
    <>
      <Header />
      <main>
        <PageHero
          overline="01 · Weekly Training Programmes"
          title="Train weekly."
          highlight="Perform always."
          description="Structured, performance-focused street dance training for children, young people and adults — delivered across London, Kent, Medway, Chatham and surrounding areas. Hip-Hop · Afro Dance · Dancehall · Krump · Amapiano · Freestyle & Battle · Performance Development."
          ctaPrimary={{ label: "Register for classes", to: "/adult-registration" }}
          ctaSecondary={{ label: "View workshops", to: "/workshops" }}
          bg={SITE.classImg1}
        />
        <Classes />
        <RelatedLinks
          title="Related"
          items={[
            { tag: "Kids", label: "USDD Kids", desc: "Junior training, ages 6–17", to: "/kids" },
            { tag: "Workshops", label: "Monthly Workshops", desc: "Social & cultural gatherings", to: "/workshops" },
            { tag: "Online", label: "Train On-Demand", desc: "Stream foundations & freestyle", to: "/online" },
          ]}
        />
      </main>
      <Footer />
    </>
  );
}
